import React from 'react';

const MapIcon = () => {
    return (
        <React.Fragment>
            <path fill="none" d="M0,0H20V20H0Z"/>
            <path d="M17.583,3l-.133.025L13,4.75,8,3,3.3,4.583a.42.42,0,0,0-.3.4v12.6A.413.413,0,0,0,3.417,18l.133-.025L8,16.25,13,18l4.7-1.583a.42.42,0,0,0,.3-.4V3.417A.413.413,0,0,0,17.583,3ZM7.167,14.792l-2.5.967V5.883l2.5-.842Zm5,1.15L8.833,14.775V5.058l3.333,1.167Zm4.167-.825-2.5.842V6.217l2.5-.967v9.867Z"
                  transform="translate(-0.5 -0.5)"/>
        </React.Fragment>
    )
}

export default MapIcon;
